import { Flex, Box, Text } from "@chakra-ui/react";
import { Translation, useTranslation } from "react-i18next";
import { getAppValue } from "src/utils/environment";
import { H4, BodyText } from "src/atoms/typography";

function SaveBadge({ save = 25 }) {
  return (
    <Translation>
      {(t) => (
        <Box
          p="2px 7px 3px 7px"
          color="white"
          bg="warningBase"
          position="absolute"
          right="50%"
          top="-2px"
          transform="translate(50%, -50%)"
          borderRadius="10px"
        >
          <Text color="white" fontSize="9px" fontWeight="500">
            {t("purchase.buy.saveBadge", { value0: save + "%" })}
          </Text>
        </Box>
      )}
    </Translation>
  );
}

export default function ProductButton({ onClick, isSelected, product }) {
  const { t } = useTranslation();
  const {
    trialPeriod,
    trialDuration,
    price,
    save,
    isEligibleForIntroductoryPrice,
    period
  } = product || {};
  const upperText = price + "/" + t(period);
  let bottomText;

  if (isEligibleForIntroductoryPrice && trialPeriod && trialDuration) {
    const capitalizedTrialPeriod =
      trialPeriod.charAt(0).toUpperCase() + trialPeriod.slice(1);
    bottomText = t(`plurals:freeX${capitalizedTrialPeriod}Trial`, {
      count: trialDuration
    });
  }

  return (
    <Flex
      onClick={onClick}
      p="16px 12px 16px 12px"
      width="194px"
      bg={isSelected ? "primaryLight" : "transparent"}
      mb="12px"
      alignItems="center"
      justifyContent="center"
      position="relative"
      height="65px"
      borderRadius="8px"
      border="2px solid"
      borderColor={isSelected ? "primary" : "primaryLight2"}
    >
      <Box>
        {save && save > 0 ? <SaveBadge save={save} /> : null}
        <H4 color="highEmphasis" textAlign="center">
          {upperText}
        </H4>
        <BodyText
          lineHeight={1}
          textAlign="center"
          color={getAppValue({
            bibino: "#9a7cf6",
            barkio: "#6eb918"
          })}
        >
          {bottomText}
        </BodyText>
      </Box>
    </Flex>
  );
}
